import AssignVoteModalContainer from './AssignVoteModalContainer';

export default AssignVoteModalContainer;
